export const EXSBPRICETYPE_DELETE_RESET = 'EXSBPRICETYPE_DELETE_RESET'
export const EXSBPRICETYPE_DELETE_SET_ERROR = 'EXSBPRICETYPE_DELETE_SET_ERROR'
export const EXSBPRICETYPE_DELETE_SET_DELETED = 'EXSBPRICETYPE_DELETE_SET_DELETED'
export const EXSBPRICETYPE_DELETE_TOGGLE_LOADING = 'EXSBPRICETYPE_DELETE_TOGGLE_LOADING'
